<template>
  <transition name="el-zoom-in-center">
    <el-card v-show="show" class="box-card" style="text-align: left">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>修改工单</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right" type="primary" @click="show = false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="form" label-width="110px" style="width: 100%" :rules="rules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="工单号" prop="orderno">
              <el-input v-model="form.orderno" style="width: 90%" clearable placeholder="请输入工单号" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="计划生产日期" prop="plan_date">
              <el-date-picker style="width: 90%" v-model="form.plan_date" type="date" value-format="yyyy-MM-dd"
                format="yyyy 年 MM 月 dd 日" clearable placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工单类型" prop="orderno_type">
              <el-select v-model="form.orderno_type" type="text" clearable style="width: 90%" value-key="value">
                <el-option v-for="item in orderstatus" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="作业方式" prop="work_type">
              <el-select v-model="form.work_type" clearable style="width: 90%">
                <el-option v-for="item in workTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="返工标识" prop="barter_flag">
              <el-select v-model="form.barter_flag" clearable style="width: 90%">
                <el-option v-for="item in barterFlagOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工厂" prop="factory_code">
              <el-select v-model="form.factory_code" type="text" clearable filterable style="width: 90%"
                @change="getWorkshopSelectList()">
                <el-option v-for="(item, index) in factorySelectList" :key="index" :label="item.factory"
                  :value="item.factory_code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="车间" prop="workshop_code">
              <el-select v-model="form.workshop_code" type="text" clearable filterable style="width: 90%"
                @change="getWorklineSelectList()">
                <el-option v-for="(item, index) in workshopSelectList" :key="index" :label="item.workshop"
                  :value="item.workshop_code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产线" prop="workline_code">
              <el-select v-model="form.workline_code" type="text" clearable filterable style="width: 90%">
                <el-option v-for="(item, index) in worklineSelectList" :key="index" :label="item.workline"
                  :value="item.workline_code" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div>
        <!-- 填写具体奖项 -->
        <h4>产品记录</h4>
        <br />
        <el-row>
          <el-col :span="11">
            <el-card shadow="never">
              <el-form ref="productform" :model="productform" label-width="140px" style="width: 80%" :rules="rules">
                <el-form-item label="产品" prop="product_code">
                  <el-select style="width:70%" v-model="productform.product_code" clearable filterable remote
                    placeholder="请输入产品名称或编码模糊匹配" :remote-method="getProductSelectList" :loading="productSelectLoading">
                    <el-option v-for="item in productSelectList" :key="item.product_code" :label="item.product"
                      :value="item.product_code" />
                  </el-select>
                </el-form-item>
                <el-form-item label="批次号" prop="batchno">
                  <el-input v-model="productform.batchno" style="width: 70%" clearable placeholder="选填" />
                </el-form-item>
                <el-form-item label="行号" prop="line_no">
                  <el-input v-model.number="productform.line_no" style="width: 70%" clearable placeholder="无批次时必填" />
                </el-form-item>
                <el-form-item label="登记证号" prop="reg_cert_no">
                  <el-input v-model="productform.reg_cert_no" style="width: 70%" clearable placeholder="选填" />
                </el-form-item>
                <el-form-item label="计划生产数量" prop="product_quantity">
                  <el-input v-model.number="productform.product_quantity" style="width: 70%" />
                </el-form-item>
                <el-form-item label="计划生产单位" prop="product_unit">
                  <el-select v-model="productform.product_unit" placeholder="请选择" style="width: 70%" remote>
                    <el-option v-for="item in unitSelectList" :key="item.product_unit_code" :label="item.product_unit"
                      :value="item.product_unit_code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div style="text-align: center">
                <el-button style="margin-top: 12px" @click="resetForm('productform')">重置</el-button>
                <el-button style="margin-top: 12px" type="primary" @click="productadd('productform')">生成</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align: center">
            <el-button @click="productadd('productform')" size="medium" style="margin-top: 100px"
              class="el-icon-d-arrow-right" />
          </el-col>
          <el-col :span="11">
            <el-card shadow="never">
              <el-table :data="tablelist" stripe style="width: 100%" height="224">
                <el-table-column prop="product_code" label="产品编码" show-overflow-tooltip />
                <el-table-column prop="batchno" label="批次号" show-overflow-tooltip />
                <el-table-column prop="line_no" label="行号" width="70" />
                <el-table-column prop="reg_cert_no" label="登记证号" min-width="100" show-overflow-tooltip />
                <el-table-column prop="product_quantity" label="计划生产数量" min-width="100" />
                <el-table-column prop="product_unit" label="计划生产单位" min-width="100" />
                <el-table-column prop="address" label="操作" width="80" fixed="right">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button type="danger" @click.native.prevent="
                        deleteRow(scope.$index, tablelist)
                        ">删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center">
          <el-button style="margin-top: 12px" type="primary" @click="submit('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>
<script>
import { orderquery, workupdate, factorylist, worklinelist, workshoplist } from "@/api/plant";
import { productlist, productunitpagelist } from "@/api/base";
export default {
  props: {
    search: {
      type: Function,
      default: null,
    }
  },
  data() {
    return {
      show: false,
      orderno: null, // 工单号 null为新增 否则为更新 
      // 基础数据
      orderstatus: [
        {
          value: 0,
          label: "自有工单",
        },
        {
          value: 1,
          label: "外协工单",
        },
        {
          value: 2,
          label: "委托加工",
        },
      ],
      workTypeOptions: [
        { value: 0, label: "普通产线" },
        { value: 1, label: "组合装产线" },
      ],
      barterFlagOptions: [
        { value: 0, label: "正常生产" },
        { value: 1, label: "返工" },
      ],
      //产品下拉选择列表
      productSelectLoading: false,
      productSelectList: [],
      // 单位下拉选择列表
      unitSelectList: [],
      // 工厂车间 产线 下拉选择列表
      factorySelectList: [],
      workshopSelectList: [],
      worklineSelectList: [],
      form: {
        orderno: null,
        plan_date: null,
        orderno_type: null,
        work_type: 0,
        barter_flag: 0,
        factory_code: null,
        workshop_code: null,
        workline_code: null,
      },
      productform: {
        // 步骤1 表单
        product_code: null,
        batchno: null,
        line_no: null,
        reg_cert_no: null,
        product_quantity: null,
        product_unit: null,
      },
      // 步骤2表格数据
      tablelist: [],
      rules: {
        orderno: [
          { required: true, message: "工单号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        batchno: [],
        line_no: [
          {
            validator: (rule, value, callback) => {
              const b = (this.productform.batchno || "").trim();
              if (!b && (value === null || value === undefined || value === "")) {
                callback(new Error("未填批次时请填写行号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        orderno_type: [
          { required: true, message: "请输入工单类型", trigger: "blur" },
        ],
        plan_date: [
          { required: true, message: "请选择生产日期", trigger: "blur" },
        ],
        product_unit: [
          { required: true, message: "请选择生产单位", trigger: "blur" },
        ],
        work_type: [
          { required: true, message: "请选择作业方式", trigger: "change" },
        ],
        factory_code: [
          { required: true, message: "请输入工厂编码", trigger: "blur" },
        ],
        product_code: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        product_quantity: [
          { required: true, message: "请输入计划生产数量", trigger: "blur", type: "number" },
        ],
      },
    };
  },
  watch: {
    'show': {
      handler(newValue, oldValue) {
        if (newValue) {
          this.resetForm('form');
          this.resetForm('productform');
          this.tablelist = [];
          this.getProductSelectList();
          this.getUnitSelectList();
          this.getFactorySelectList();
          this.getOrderInfo().finally(() => {
            this.getWorkshopSelectList(this.form.workshop_code, this.form.workline_code);
            this.getWorklineSelectList(this.form.workline_code);
          });
        }
      },
      deep: true
    },
    'form.factory_code': {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.workshopSelectList = [];
          this.worklineSelectList = [];
          this.form.workshop_code = null;
          this.form.workline_code = null;
        }
      },
      deep: true
    },
    'form.workshop_code': {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.worklineSelectList = [];
          this.form.workline_code = null;
        }
      },
      deep: true
    },
  },
  methods: {
    // 获取产品下拉列表
    getProductSelectList(value) {
      if (value !== "") {
        this.productSelectLoading = true;
        setTimeout(() => {
          this.productSelectLoading = false;
          productlist({ productName: value }).then(response => {
            this.productSelectList = response.data.data || [];
            for (var item of this.productSelectList) {
              item.product = item.product_code + " - " + item.product_name;
            }
          });
        }, 200);
      } else {
        this.productSelectList = [];
      }
    },
    // 获取单位下拉列表
    getUnitSelectList() {
      this.unitSelectList = [];
      productunitpagelist({ status: 0, pageindex: 1, pageSize: 99, }).then((response) => {
        this.unitSelectList = response.data.data;
        for (var item of this.unitSelectList) {
          item.product_unit = item.product_unit_code + " - " + item.product_unit_cn;
        }
      });
    },
    // 获取工厂下拉列表
    getFactorySelectList() {
      factorylist({ pageSize: 10000 }).then((response) => {
        this.factorySelectList = response.data.data;
        for (var item of this.factorySelectList) {
          item.factory = item.factory_code + " - " + item.factory_name;
        }
      });
    },
    // 获取车间下拉列表
    getWorkshopSelectList(defaultWorkshopCode, defaultWorklineCode) {
      this.workshopSelectList = [];
      this.worklineSelectList = [];
      this.form.workshop_code = defaultWorkshopCode || null;
      this.form.workline_code = defaultWorklineCode || null;
      if (this.form.factory_code) {
        workshoplist({ factory_code: this.form.factory_code, pageSize: 10000 }).then((response) => {
          this.workshopSelectList = response.data.data;
          for (var item of this.workshopSelectList) {
            item.workshop = item.workshop_code + " - " + item.workshop_name;
          }
        });
      }
    },
    // 获取产线下拉列表
    getWorklineSelectList(defaultWorklineCode) {
      this.worklineSelectList = [];
      this.form.workline_code = defaultWorklineCode || null;
      if (this.form.workshop_code) {
        worklinelist({ workshop_code: this.form.workshop_code, pageSize: 10000 }).then((response) => {
          this.worklineSelectList = response.data.data;
          for (var item of this.worklineSelectList) {
            item.workline = item.workline_code + " - " + item.workline_name;
          }
        });
      }
    },
    // 获取订单信息
    async getOrderInfo() {
      var response = await orderquery({ orderno: this.orderno });
      const rows = response.data.data || [];
      this.form = Object.assign({}, rows[0] || {}, {
        work_type: rows[0] && rows[0].work_type != null ? rows[0].work_type : 0,
        barter_flag: rows[0] && rows[0].barter_flag == 1 ? 1 : 0,
      });
      this.tablelist = rows.map((r) => ({
        ...r,
        line_no: r.line_no != null ? r.line_no : 0,
        reg_cert_no: r.reg_cert_no || null,
      }));
    },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.tablelist.length == 1) {
          //   this.$message({
          //     type: "warning",
          //     message: "只能添加一个产品",
          //   });
          //   return
          // }
          let obj = {};
          obj = Object.assign({}, this.productform)
          const nb = (this.productform.batchno || "").trim();
          const nl = this.productform.line_no != null && this.productform.line_no !== "" ? Number(this.productform.line_no) : 0;
          for (let i = 0; i < this.tablelist.length; i++) {
            const row = this.tablelist[i];
            const rb = (row.batchno || "").trim();
            const rl = row.line_no != null && row.line_no !== "" ? Number(row.line_no) : 0;
            const sameKey =
              row.product_code === this.productform.product_code &&
              rb === nb &&
              (!nb ? rl === nl : true);
            if (sameKey) {
              row.product_quantity += this.productform.product_quantity;
              this.$refs[formName].resetFields();
              return;
            }
          }
          this.tablelist.push(obj);
          this.resetForm(formName);
        } else {
          return false;
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 保存提交
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        // 基础表单验证
        if (valid) {
          if (this.tablelist.length == 0) {
            this.$message({
              type: "warning",
              message: "请添加产品",
            });
            return;
          }
          workupdate({
            id: this.form.id,
            orderno: this.form.orderno,
            orderno_type: this.form.orderno_type,
            work_type: this.form.work_type,
            barter_flag: this.form.barter_flag == 1 ? 1 : 0,
            factory_code: this.form.factory_code,
            workshop_code: this.form.workshop_code,
            workline_code: this.form.workline_code,
            workline_name: this.form.workline_name,
            plan_date: this.form.plan_date,
            workorderProducts: this.tablelist.map((r) => ({
              id: r.id,
              product_code: r.product_code,
              batchno: r.batchno || null,
              line_no: r.line_no != null && r.line_no !== "" ? Number(r.line_no) : 0,
              reg_cert_no: r.reg_cert_no || null,
              product_quantity: r.product_quantity,
              product_unit: r.product_unit,
            })),
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              this.show = false;
              this.resetForm('form');
              this.resetForm('productform');
              this.tablelist = [];
              this.search();
            } else {
              this.$message({
                type: "warning",
                message: "提交失败!请检查字段",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
